import { useEffect } from 'react'
import { useAuthStore } from '@/stores/auth.store'
import { resumeKmRendersFromServer } from '@/lib/kmRenderPoll'

/** After F5: restore in-progress KM renders from backend, not sessionStorage. */
export function useKmRenderResume() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const role = useAuthStore((s) => s.role)

  useEffect(() => {
    if (!isAuthenticated || role !== 'admin') return
    void resumeKmRendersFromServer()
  }, [isAuthenticated, role])
}
